import { Grid } from '@material-ui/core'
import { useState } from 'react'
import { Button, useNotify } from 'react-admin'
import Api from '../../../Apis/api.service'
import { useStyles } from '../styles'

export const Passerelle = ({
  setIsChanged,
  setOpenResolutionId,
  onSuccess,
  ...props
}) => {
  const classes = useStyles()
  const [disabled_btn, setDisabledBtn] = useState(false)

  const notify = useNotify()
  const { record } = props
  if (!record.allowpasserelle || record.status != 'Contre') {
    return null
  }
  const createPasserelle = async (e) => {
    e.preventDefault()
    setDisabledBtn(true)
    const result = await Api.resolutions.createPasserelle(record)
    setDisabledBtn(false)
    const { data } = result
    if (result.status === 200) {
      onSuccess(data)
      notify(
        'Vous avez créez une sous résolution avec MAJORITE ' + data.majorite_bo
      )
      setIsChanged((prev) => {
        let newVal = new Date().getTime()
        return newVal
      })
      setDisabledBtn(false)
      setOpenResolutionId((prev) => {
        return data.id
      })
    } else {
      notify(`${data.message}`)
      setDisabledBtn(false)
    }
    setDisabledBtn(false)
  }

  return (
    <Grid item xs={12}>
      <Button
        variant="contained"
        color="secondary"
        className={classes.actionButton}
        size="normal"
        label="Voter en passerelle"
        disabled={disabled_btn}
        onClick={createPasserelle}
      />
    </Grid>
  )
}
export default Passerelle
